export default __webpack_public_path__ + "static/media/icon-email-sent.7ea506ea.svg";